<template>
	<div>
		<div class="note2">
			<div class="note2-title">{{data.title}}</div>
			<div class="note2-from">
				<div class="o1">课程名称：{{data.course_title}}</div>
				<div class="o1">课程章节：{{data.section_title}}</div>
			</div>
			<div class="note2-info f-cb">
				<div class="note2-avatar f-img-box" @click="$router.push('/other/history/'+data.user_id)">
					<img :src="data.avatar?data.avatar:studentAvatar">
				</div>
				<div class="note2-info2">
					<div class="note2-name" @click="$router.push('/other/history/'+data.user_id)">{{data.nick_name}}</div>
					<div class="note2-time">{{tools.timestampConversion(data.create_time)}}</div>
				</div>
			</div>
			<div class="note2-content" v-html="data.content"></div>
			<div class="note2-line f-cb">
				<div class="note2-fav" @click="fav" :class="{'note2-fav-active':isLike}">{{data.like_num}}</div>
				<!--<div class="note2-link">相关课程</div>-->
				<div class="note2-link" @click="isReplyDialogOpen=true">回复</div>
				<div class="note2-get" @click="collect">采集</div>
			</div>
		</div>
		<div class="answer" v-dt-infinite-scroll="getData">
			<ul class="answer-items">
				<!--<li class="answer-item f-cb">
					<div class="answer-avatar f-img-box">
						<img src="../index/teacher.png">
					</div>
					<div class="answer-content">
						<div class="answer-name">姓名</div>
						<div class="answer-text">么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率比较高？老师，请问怎么样效率</div>
						<div class="answer-info f-cb">
							<div class="answer-time">2小时前</div>
							<div class="answer-button">回复</div>
						</div>
						<div class="answer-reply">
							<ul class="answer-reply-items">
								<li class="answer-reply-item"><span>淘气的棉花糖：</span>老师，请问怎么样效率比较高老师，请问怎么样效率比较高</li>
								<li class="answer-reply-item"><span>淘气花糖：</span>谢谢</li>
							</ul>
						</div>
					</div>
				</li>-->
				<li class="answer-item f-cb" v-for="item in reply">
					<div class="answer-avatar f-img-box" @click="$router.push('/other/history/'+item.user_id)">
						<img :src="item.avatar?item.avatar:studentAvatar">
					</div>
					<div class="answer-content">
						<div class="answer-name" @click="$router.push('/other/history/'+item.user_id)">{{item.nick_name}}</div>
						<div class="answer-text">{{item.content}}</div>
						<div class="answer-info f-cb">
							<div class="answer-time">{{tools.timestampConversion(item.create_time)}}</div>
							<div class="answer-button" @click="isReplyDialogOpen=true">回复</div>
						</div>
						<!--<div class="answer-reply">
							<ul class="answer-reply-items">
								<li class="answer-reply-item"><span>淘气的棉花糖：</span>老师，请问怎么样效率比较高老师，请问怎么样效率比较高</li>
								<li class="answer-reply-item"><span>淘气花糖：</span>谢谢</li>
							</ul>
						</div>-->
					</div>
				</li>
			</ul>
		</div>
		<dialog-mask :open="isReplyDialogOpen">
			<div class="reply-dialog">
				<div class="reply-dialog-line f-cb">
					<!--<div class="reply-dialog-text">回复 会跳的毛毛虫</div>-->
					<div class="reply-dialog-close" @click="isReplyDialogOpen=false">×</div>
				</div>
				<div class="reply-dialog-area">
					<textarea placeholder="请在这里输入回复内容..." v-model="replyContent"></textarea>
				</div>
				<!--<div class="reply-dialog-num">0/200</div>-->
				<div class="reply-dialog-button">
					<button type="button" @click="submitReply">确定</button>
				</div>
			</div>
		</dialog-mask>
	</div>
</template>

<script>
	import mask from "../mask/mask.vue"
	export default{
		data(){
			return{
				data:{},
				reply:[],
				isLike:false,
				isReplyDialogOpen:false,
				replyContent:"",
				courseId:""
			}
		},
		created(){
		  //获取笔记详情
      this.$api.get("",{
        api:"/v1/section_note/read",
        note_id:this.$route.params.id,
        user_type:this.tools.getStorage("user_type")
      },res=>{
        var data=res.data;
        this.data=data.note;
        this.courseId=data.note.course_id;
        this.isLike=data.note.is_like;
      })
		},
		components:{
			"dialog-mask":mask
		},
		methods:{
			getData(page){
			  var length=10;
			  return new Promise((resolve,reject)=>{
          this.$api.get("",{
            api:"/v1/section_note/read",
            note_id:this.$route.params.id,
            user_type:this.tools.getStorage("user_type"),
            page,
            len:length
          },res=>{
            var data=res.data.replyList;
            this.reply=this.reply.concat(data);
            if(data.length<length){
              reject();
            }
            else{
              resolve();
            }
          })
        })
			},
			submitReply(){
				this.$api.get("",{
					api:"/v1/section_note/reply",
					note_id:this.$route.params.id,
					content:this.replyContent,
					user_type:this.tools.getStorage("user_type")
				},res=>{
          if(res.status==1){
            this.$toast("评论成功");
            this.isReplyDialogOpen=false;
            this.replyContent="";
          }else{
            this.$toast(res.msg);
          }
				})
			},
			collect(){
				this.$api.get("",{
					api:"/v1/section_note/collect_note",
					id:this.$route.params.id,
					user_type:this.tools.getStorage("user_type")
				},res=>{
					this.$toast("采集成功");
				})
			},
			fav(){
				this.$api.get("",{
					api:"/v1/section_note/addLike",
					id:this.$route.params.id,
					user_type:this.tools.getStorage("user_type")
				},res=>{
					this.isLike=true;
					this.$toast("点赞成功");
					this.data.like_num+=1;
				})
			}
		}
	}
</script>

<style>
	.note2{
		padding:0.613rem 0.4rem 0 0.4rem;
	}
	.note2-title{
		font-size: 0.506rem;
		line-height:0.773rem;
		font-weight: bold;
		color:#333;
	}
	.note2-from{
		margin-top:0.133rem;
		font-size: 0.346rem;
		line-height:0.693rem;
		color:#999;
	}
	.note2-info{
		margin-top:0.4rem;
	}
	.note2-avatar{
		float:left;
		overflow: hidden;
		height:1.146rem;
		width:1.146rem;
		border-radius: 50%;
	}
	.note2-info2{
		float:left;
		margin-left:0.28rem;
		margin-top:0.173rem;
		font-size: 0.346rem;
		line-height: 0.346rem;
	}
	.note2-name{
		color:#666;
	}
	.note2-time{
		margin-top:0.133rem;
		color:#999;
	}
	.note2-content{
		margin-top:0.333rem;
		font-size: 0.373rem;
		line-height:0.56rem;
	}
	.note2-content img{
		max-width: 100%!important;
	}
	.note2-line{
		margin-top:0.213rem;
		height:0.8rem;
		padding-bottom: 0.533rem;
		line-height:0.8rem;
		border-bottom: 1px solid #ccc;
	}
	.note2-fav{
		float:left;
		padding-left:0.533rem;
		color:#FF3939;
		font-size:0.373rem;
		background: url(../lesson-evaluate/fav.png) left center no-repeat;
		background-size: 0.32rem;
		color:#999;
	}
	.note2-fav-active{
		color:#FF3939;
		background-image: url(../lesson-evaluate/fav-active.png)
	}
	.note2-get{
		float:right;
		width:1.506rem;
		height:0.8rem;
		margin-right:0.533rem;
		color:#fff;
		background:#ec6d3a;
		font-size: 0.373rem;
		text-align: center;
		border-radius: 0.133rem;
	}
	.note2-link{
		float:right;
		color:#3192E0;
		font-size: 0.373rem;
	}
	.answer-item{
		margin:0 0.4rem;
		padding:0.533rem 0;
		border-bottom:1px solid #cccccc;
	}
	.answer-item:last-child{
		border-bottom:0;
	}
	.answer-avatar{
		float:left;
		overflow: hidden;
		width:1.2rem;
		height:1.2rem;
		border-radius: 50%;
	}
	.answer-content{
		float:right;
		width:7.733rem;
		padding-top:0.2rem;
	}
	.answer-content img{
		max-width: 100%!important;
	}
	.answer-name{
		font-size: 0.373rem;
		line-height: 0.373rem;
		color:#ec6d3a;
	}
	.answer-text{
		margin-top:0.173rem;
		font-size: 0.346rem;
		line-height:0.506rem;
	}
	.answer-info{
		margin-top:0.173rem;
		line-height: 0.346rem;
	}
	.answer-time{
		float:left;
		font-size: 0.266rem;
		color:#999;
	}
	.answer-button{
		float:right;
		font-size: 0.346rem;
		color:#3192e0;
	}
	.answer-reply{
		margin-top: 0.253rem;
		width:6.92rem;
		padding:0.173rem 0.4rem;
		background: #eee;
	}
	.answer-reply-item{
		color:#999;
		font-size: 0.346rem;
		line-height:0.506rem;
	}
	.answer-reply-item span{
		color:#666;
	}
	.reply-dialog{
		padding:0.506rem 0.4rem 0.4rem 0.4rem;
		width:8.4rem;
		background: #f3f3f3;
	}
	.reply-dialog-line{
		font-size: 0.346rem;
		line-height: 0.346rem;
	}
	.reply-dialog-text{
		float:left;
		color:#999;
	}
	.reply-dialog-close{
		float:right;
	}
	.reply-dialog-area{
		margin-top:0.293rem;
		text-align: center;
	}
	.reply-dialog-area textarea{
		box-sizing: border-box;
		padding:0.4rem;
		height:3.52rem;
		width:100%;
		border:1px solid #f3f3f3;
		background: #fff;
		border-radius: 0.133rem;
	}
	.reply-dialog-num{
		line-height:0.573rem;
		font-size: 0.346rem;
		text-align: right;
		color:#999;
	}
	.reply-dialog-button{
		margin-top:0.266rem;
		text-align: center;
	}
	.reply-dialog-button button{
		width:4.533rem;
		height:1.093rem;
		background:#ec6d3a;
		font-size: 0.426rem;
		color:#fff;
		border-radius:0.133rem;
		border:0;
	}
</style>



// WEBPACK FOOTER //
// src/components/note/note.vue